<template>
  <div class="base-wrapper index-wrapper">
    <!-- 头部标题 -->
    <headline
      :params="headerData"
      @onCancel="cancelHandler"
    >
    </headline>
    <div class="scroll-wrapper">
      <!-- 服务流程 && 服务说明 -->
      <div class="index-flow section">
        <p class="index-flow-title bold">
          {{ pageData.serviceProcessName }}
        </p>
        <div class="index-flow-img">
          <img :src="pageData.serviceProcessPicLink" />
        </div>
        <p class="index-flow-title bold">
          {{ pageData.serviceNoticeName }}
        </p>
        <div
          class="index-flow-html"
          v-html="pageData.serviceNoticeInfo"
        ></div>
      </div>

      <!-- 扣款账户 -->
      <div class="index-account section">
        <div class="index-account-info bold">
          {{ deductOrderInfo.deductOrderName }}
        </div>
        <div
          class="flex-align"
          @click="showOrderPage"
        >
          <span>
            {{ deductOrderInfo.subPayTypeDescription }}
          </span>
          <i class="icon-access access-left"></i>
        </div>
      </div>
    </div>
    <div
      v-if="reversionId === 1"
      class="container-bottom-info absolute-bottom"
    >
      <!-- 开通 button -->
      <div class="button-line">
        <button
          class="go-service"
          @click="guideSignPayHandler"
        >
          {{ btnText }}
        </button>
        <div
          v-if="marketingInfo.bubbleText"
          class="badge ellipsis"
        >
          {{ marketingInfo.bubbleText }}
        </div>
      </div>

      <!-- 相关协议 -->
      <div
        v-if="agreementInfo.length"
        class="index-agreement center"
      >
        <span>点击按钮即表示你已阅读并同意</span>
        <span
          class="highlight"
          @click="showAgreementPage()"
        >
          先用后付相关协议
        </span>
      </div>
    </div>
    <div
      v-if="reversionId === 2"
      class="container-bottom-info absolute-bottom add-pay"
    >
      <!-- 相关协议 -->
      <div
        v-if="agreementInfo.length"
        class="paydefer-agreement center"
      >
        <span>点击按钮即表示你已阅读并同意</span>
        <span
          class="highlight"
          @click="showAgreementPage()"
        >
          先用后付相关协议</span
        >
      </div>
      <!-- 开通 button -->
      <div class="button-line">
        <button
          class="go-service"
          @click="qualifyDispatcher"
        >
          {{ btnText }}
        </button>
        <div
          v-if="marketingInfo.bubbleText"
          class="badge ellipsis"
        >
          {{ marketingInfo.bubbleText }}
        </div>
      </div>
      <!-- 暂不开通，直接去支付 button -->
      <div class="button-line bottom-line">
        <button
          class="go-pay"
          @click="goPay"
        >
          {{ pageData.subButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { normalizeError } from '@mx/pay-common';
import {
  env,
  bridge,
  homePage,
  metricPoints,
  monitor,
  OpenType,
  PageType,
  payDeferHomePage,
  ReversionId,
  VisiblePage,
  getDeductionOrderPageUrl,
} from '@/common';
import {
  fetchGuideSign,
  cancelDefer,
  showErrorModal,
  initPagePromise,
  fetchQualifyDispatcher,
  downgradeStandardCashier,
} from '@/service';
import { lx } from '@/analytic';
import { bids, cids } from '@/analytic/lx-constants';
import Headline from './Headline.vue';

export default Vue.extend({
  name: 'App',
  components: { Headline },
  props: {
    openType: {
      type: Number,
      default: OpenType.InpaySign,
    },
  },
  data() {
    return {
      pageData: {} as HomePageType,
      reversionId: env.reversionId,
    };
  },
  computed: {
    headerData(): HeaderDataType {
      return {
        title: this.pageData.title,
      };
    },
    btnText(): string {
      return this.openType === OpenType.IndependenceSign ? '开启服务' : this.pageData.buttonText || '确认，去支付';
    },
    pageType(): PageType {
      return this.openType === OpenType.IndependenceSign ? PageType.home : PageType.index;
    },
    // 扣费账户相关数据
    deductOrderInfo(): DeductOrderInfoType {
      return this.pageData.deductOrderInfo || {};
    },

    // 营销气泡数据
    marketingInfo(): MarketingInfoType {
      return this.pageData.marketingInfo || {};
    },

    // 协议文案及链接
    agreementInfo(): AgreementType[] {
      return this.pageData.agreementInfo || [];
    },
  },

  created() {
    // 设置页面签约流程
    env.setOpenType(this.openType);
    env.setPerformanceOpenType();

    initPagePromise(this.pageType)
      .then(this.init)
      .then(() => {
        if (env.hideHalfPage) {
          fetchGuideSign();
        }
      })
      .catch((error: any) => {
        monitor.captureAjaxErrorMessage(`[api]${this.pageType}签约组件调用异常`, { error: normalizeError(error) });
      });
  },
  mounted() {
    bridge.setLLButton(this.cancelHandler);
  },
  methods: {
    init() {
      const scorePlanId =
        this.reversionId === ReversionId.ImproveCTR ? { scorePlanId: env.coreBusinessParams.scorePlanId } : {};
      const apiHomePage = this.reversionId === ReversionId.ImproveCTR ? payDeferHomePage : homePage;
      const openType = this.reversionId === ReversionId.ImproveCTR ? env.performanceOpenType : env.openType;
      return apiHomePage({
        ...env.inpayBasicBusinessParams,
        ...scorePlanId,
        outer_business_data: env.outerBusinessData, // payDeferHomePage 接口暂未通过解析此字段来获取 scorePlanId，后端后续需调整
        openType,
        entry: env.entry,
      })
        .then((res) => {
          this.pageData = res;
          // 保存商户号，后续接口使用
          env.setIphPayMerchantNo(res.iphPayMerchantNo);
          // 保存 utmSource, 获客链路优化调整优先使用url上的utm
          const utmSource = env.hideHalfPage ? env.urlUtmSource : res.marketingInfo?.utmSource;
          env.setUtmSource(utmSource || '');
          // 后端下发 subPayTypeDescription 字段时上报曝光，目前所有都会下发 - 20210917
          if (this.pageData?.deductOrderInfo?.subPayTypeDescription) {
            lx.mv(bids.showOrderBtn, {}, { cid: cids.index });
          }
          if (this.pageData?.marketingInfo?.bubbleText) {
            lx.mv(bids.bubbleTextMV, {}, { cid: cids.index });
          }
          const duration = performance.now();
          lx.pv(cids.index, { duration, paramTunnelTime: Date.now() - env.paramTunnelTime });

          // stat_time 里第一个值是半页容器起始点， 暂时注释，待native 修复后调整上报逻辑
          // const statTimeStart = env.statCommonParams.stat_time?.split(',')?.[0] || 0;
          // 使用 NEO 返回的起始点上报数据，金服 TTI，对应 21 测速点
          // monitor.reportPoint(20, Date.now() - statTimeStart);
          monitor.reportPoint(20);
          monitor.reportMetric(metricPoints.showIndexPage);
        })
        .catch((error) => {
          showErrorModal({ resultData: error });
          monitor.captureAjaxErrorMessage('[api]首页接口请求失败', { error: normalizeError(error) });
        });
    },

    guideSignPayHandler() {
      fetchGuideSign();
    },

    qualifyDispatcher() {
      env.setBizSerialNo('');
      lx.mc(bids.signPayBtn, {}, { cid: cids.index });
      fetchQualifyDispatcher();
    },

    showAgreementPage() {
      this.$emit('toggleVisiblePage', VisiblePage.agreement, this.agreementInfo, 0);
    },

    showOrderPage() {
      lx.mc(bids.clickOrderBtn, {}, { cid: cids.index });
      // this.$emit('toggleVisiblePage', VisiblePage.order, link);
      getDeductionOrderPageUrl(this.pageData.mtPlanId || '');
    },

    cancelHandler() {
      cancelDefer();
    },

    goPay() {
      lx.mc(bids.goPayBtn, {}, { cid: cids.index });
      downgradeStandardCashier();
    },
  },
});
</script>

<style lang="less" scoped>
@import '../../styles/variable.less';

.index-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 0 0.3rem;

  .scroll-wrapper {
    flex: 1;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    margin-bottom: 2.5rem;
    -webkit-overflow-scrolling: touch;
  }

  .index-flow {
    padding: 0 0.3rem 0.3rem;
  }

  .index-flow-title {
    line-height: 0.36rem;
    font-size: 0.28rem;
    color: @mainText;
    padding: 0.23rem 0 0;
  }

  .index-flow-img {
    display: flex;
    padding: 0.44rem 0 0.22rem;
    justify-content: center;
    img {
      height: 0.88rem;
    }
  }

  .index-flow-html {
    font-size: 0.24rem;
    padding-top: 0.14rem;
    color: rgba(0, 0, 0, 0.7);
    line-height: 0.4rem;
  }

  .index-account {
    display: flex;
    justify-content: space-between;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.28rem;
    color: @mainText;
    padding: 0 0.3rem 0 0.42rem;

    i {
      font-size: 0.2rem;
      color: #a6a6a6;
    }
  }

  .section {
    background: @gray;
    border-radius: @sectionRadius;
    margin-bottom: @sectionMargin;
    overflow: hidden;
  }
  .index-agreement {
    padding-bottom: 0.06rem;
  }
  .paydefer-agreement {
    line-height: 1;
  }
  .add-pay {
    padding-bottom: 0.08rem;
  }
  .go-pay {
    line-height: 1.6;
    height: 0.5rem;
    background: none;
    font-weight: normal;
  }
}
</style>
